var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.plan && _vm.plan.trialDays)?_c('div',{staticClass:"trial-timeline-with-reminder-step"},[_c('timeline',{attrs:{"steps":_vm.steps}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }